import { render, staticRenderFns } from "./BtnInserirDocumentosLicitacao.vue?vue&type=template&id=33abfbf1"
import script from "./BtnInserirDocumentosLicitacao.vue?vue&type=script&lang=js"
export * from "./BtnInserirDocumentosLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports